import { FlagsPermissionHubToHub } from "@/feature-flags/flags-permission-hub-to-hub";
const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const HubToHub = () =>
  import(
    /* webpackChunkName: "HubToHub" */ "@/app/ui/views/hub-to-hub/index.vue"
  );
const TabInHub = () =>
  import(
    /* webpackChunkName: "TabInHub" */ "@/app/ui/views/hub-to-hub/modules/in-hub.vue"
  );
const TabOutHub = () =>
  import(
    /* webpackChunkName: "TabOutHub" */ "@/app/ui/views/hub-to-hub/modules/out-hub.vue"
  );
const UpdateInHub = () =>
  import(
    /* webpackChunkName: "UpdateInHub" */ "@/app/ui/views/hub-to-hub/modules/updates/in-hub.vue"
  );
const UpdateOutHub = () =>
  import(
    /* webpackChunkName: "UpdateOutHub" */ "@/app/ui/views/hub-to-hub/modules/updates/out-hub.vue"
  );

const maskedPath = new Date().getTime() + Math.random() + "";
export default [
  {
    path: "/hub-to-hub",
    name: "hub-to-hub",
    component: Layout,
    meta: {
      icon: "sti",
      children: false,
      header: true,
      title: "Hub to Hub",
      name: "Hub to Hub",
      maskedPath: maskedPath,
      gtmEventName: "hub_to_hub_menu_clicked",
      gtmEventCustoms: {},
      gtmEventOption: ["userType", "timestamp", "userId"],
      permission: FlagsPermissionHubToHub.hub_menu_enable
    },
    children: [
      {
        path: "",
        name: "hub-to-hub",
        component: HubToHub,
        redirect: "/hub-to-hub/in-hub",
        meta: {
          header: true,
          icon: "sti",
          title: "Hub to Hub",
          name: "Hub to Hub",
          maskedPath: maskedPath,
          gtmEventName: "hub_to_hub_submenu_clicked",
          gtmEventCustoms: {},
          gtmEventOption: ["userType", "timestamp", "userId"],
          permission: FlagsPermissionHubToHub.in_hub_list
        },
        children: [
          {
            path: "in-hub",
            name: "hub-to-hub-in-hub",
            component: TabInHub,
            meta: {
              tab: "hub-to-hub-in-hub",
              maskedPath: maskedPath,
              permission: FlagsPermissionHubToHub.in_hub_list
            }
          },
          {
            path: "out-hub",
            name: "hub-to-hub-out-hub",
            component: TabOutHub,
            meta: {
              tab: "hub-to-hub-out-hub",
              maskedPath: maskedPath,
              permission: FlagsPermissionHubToHub.out_hub_list
            }
          }
        ]
      }
    ]
  },
  {
    path: "/hub-to-hub",
    component: Layout,
    name: "update-in-hub",
    meta: {
      icon: "sti",
      hidden: true,
      parent: "Hub to Hub",
      maskedPath,
      permission: FlagsPermissionHubToHub.in_hub_create
    },
    children: [
      {
        path: "update-in-hub",
        name: "update-in-hub",
        component: UpdateInHub,
        meta: {
          header: true,
          title: "Hub to Hub | Update In Hub",
          name: "Update In Hub",
          before: "/hub-to-hub",
          maskedPath
        }
      }
    ]
  },
  {
    path: "/hub-to-hub",
    component: Layout,
    name: "update-out-hub",
    meta: {
      icon: "sti",
      hidden: true,
      parent: "Hub to Hub",
      maskedPath,
      permission: FlagsPermissionHubToHub.out_hub_create
    },
    children: [
      {
        path: "update-out-hub",
        name: "update-out-hub",
        component: UpdateOutHub,
        meta: {
          header: true,
          title: "Hub to Hub | Update Out Hub",
          name: "Update Out Hub",
          before: "/hub-to-hub",
          maskedPath
        }
      }
    ]
  }
];
